export default __webpack_public_path__ + "static/media/list.7b8eb7e9.svg";